import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const approaches = ['Las dietas de "contar calorías" bloquean tu tiroides y ralentizan aún más tu metabolismo maduro.', 'El ejercicio intenso eleva el cortisol, la hormona que mantiene tu vientre inflamado y firme.', 'Los jugos "detox" genéricos tienen demasiada fructosa, disparando tu insulina y causándote más hambre.', 'Ignorar el cambio hormonal femenino hace que tu cuerpo guarde cada carbohidrato como grasa de reserva inmediata.'];
export function FailedApproaches() {
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-15">
          Por qué lo que intentaste no funcionó
        </motion.h2>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-16">
          {approaches.map((text, index) => <motion.div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-rose/20 flex items-start gap-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-17">
              <XCircle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" data-id="element-18" />
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-19">
                {text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}